module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_Italy-ItalianStu.83a12e3c.jpg";